import { AllConsentNames } from "c15t"
import {
  ConsentStore,
  JurisdictionRules,
  PrivacySignal
} from "cookiesConsent/domain/jurisdiction"
import {
  UserConsent,
  functional,
  performance,
  targeting
} from "cookiesConsent/domain/consent"

export type C15tCategorySeed = Record<AllConsentNames, boolean>

export interface C15tConsentManager {
  setSelectedConsent: (name: AllConsentNames, value: boolean) => void
  saveConsents: (type: `custom`) => Promise<void> | void
  hasConsented: () => boolean
}

export const c15tConsentSeed = (consent: UserConsent): C15tCategorySeed => ({
  necessary: true,
  functionality: consent.permits(functional),
  measurement: consent.permits(performance),
  marketing: consent.permits(targeting),
  experience: false
})

export class C15tConsentStore implements ConsentStore {
  private readonly manager: C15tConsentManager

  constructor(manager: C15tConsentManager) {
    this.manager = manager
  }

  grant = async (consent: UserConsent): Promise<void> => {
    const seed = c15tConsentSeed(consent)
    this.manager.setSelectedConsent(`necessary`, seed.necessary)
    this.manager.setSelectedConsent(`functionality`, seed.functionality)
    this.manager.setSelectedConsent(`measurement`, seed.measurement)
    this.manager.setSelectedConsent(`marketing`, seed.marketing)
    await this.manager.saveConsents(`custom`)
  }

  reconcile = async (
    rules: JurisdictionRules,
    signal: PrivacySignal
  ): Promise<void> => {
    if (this.manager.hasConsented()) {
      return undefined
    } else {
      return rules.bannerMode().reconcile(this, rules.defaultConsent(signal))
    }
  }
}
